import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useContext, useState, useEffect} from 'react';
import { ContextFromSelections } from './Context';


export default function UserExtraOptions() {
  const [selectedData,setSelectedData] =  useContext(ContextFromSelections)
  const [extraOptions,setExtraOptions] = useState(selectedData.extra_options_byuser)

  const handleCommentChange = (event) => {
    setExtraOptions(event.target.value)
  }

  useEffect(() => {
    setSelectedData((data) => ({...data,extra_options_byuser: extraOptions}))

  },[extraOptions])



  return (
    <Box
      sx={{ 
        margin: 'auto',
        display: "flex",
        justifyContent: {xs:"center", sm: "center", md: "right"},
        alignItems: "center", 
        paddingTop: {md: 2, xs: 0},
        height: {md: 100, sm: 100, xs: 150},
        // border: "2px solid blue"
      }}
      
      autoComplete="off"
    >
        
        <TextField
          size='small'
          value={selectedData.extra_options_byuser || ""}
          onChange={handleCommentChange}
          multiline
          maxRows={2}
          // id="outlined-helperText"
          label="Extra Options"
          helperText="Describe any considerations that aren't shown in the options"
          
        />
    
    </Box>
  );
}
